import React from "react";
import Svg, { Path, Circle } from "react-native-svg";

const GreenStar = (props) => {
  return (
    <Svg
      width="14"
      height="14"
      viewBox="0 0 14 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <Circle cx="7" cy="7" r="7" fill="#27AE60" />
      <Path
        d="M7 2L8.12257 5.45492H11.7553L8.81636 7.59017L9.93893 11.0451L7 8.90983L4.06107 11.0451L5.18364 7.59017L2.24472 5.45492H5.87743L7 2Z"
        fill="white"
      />
    </Svg>
  );
};

export default GreenStar;
